import useMenuItemCheckCircularReference from '../../../menuItems/useMenuItemCheckCircularReference.jsx'
import useMenuItemLintForCode from '../../../menuItems/useMenuItemLintForCode.jsx'
import useMenuItemLintForDoc from '../../../menuItems/useMenuItemLintForDoc.jsx'
import MenuButton from '../../MenuButton.jsx'

export default function MenuButtonLint(props) {
    const items = [
        useMenuItemLintForCode(),
        //useMenuItemLintForDoc(),
        useMenuItemCheckCircularReference(),
    ]

    return (
        <MenuButton
            items={items}
            {...props}
        >
            规范性检测
        </MenuButton>
    )
}
